import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation
} from '@angular/core';
import { Module, TextPosition } from 'projects/common/model/ModuleModel';
import { ScreenType } from 'projects/common/model/ScreenType';

type TextLayoutVariant = 'TOP' | 'SIDE' | 'SIDE_REVERSED';
interface TextLayoutConfig {
    variant: TextLayoutVariant;
    showSideTitle: boolean;
    showMainTitle: boolean;
    verticalAlign?: 'TOP' | 'CENTER' | 'BOTTOM'

}

@Component({
    selector: 'text-layout',
    template: `
    <ng-template #titleTpl>
        <text *ngIf="module.pretitle || module.title || module.subtitle"
            [data]="module"
            [uniqueId]="module.unique_id"
            [moduleId]="module.id"
            [moduleIndex]="module.row_number"
            [verticalAlign]="layout.verticalAlign">
        </text>
    </ng-template>

    <div class="module-layout"
     [ngClass]="{
        'module-layout--side': layout.variant === 'SIDE',
        'module-layout--side-reversed': layout.variant === 'SIDE_REVERSED'
     }">

        <div *ngIf="layout.showMainTitle"
            class="module-layout__title module-layout__title--top">
            <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
        </div>

        <div class="module-layout__row">
            <div *ngIf="layout.showSideTitle" class="module-layout__title module-layout__title--side">
                <ng-container *ngTemplateOutlet="titleTpl"></ng-container>
            </div>

            <div class="module-layout__content">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
`,
    styleUrls: ['./text-layout.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TextLayoutComponent implements OnChanges {

    @Input() textPosition?: TextPosition = TextPosition.TOP;
    @Input() screenType!: ScreenType;
    @Input() isFullWidth = false;
    @Input() module!: Module;

    layout!: TextLayoutConfig;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['textPosition'] || changes['screenType']) {
            this.layout = this.resolveTextLayout(this.textPosition, this.screenType);
        }
    }

    resolveTextLayout(
        textPosition: TextPosition | null | undefined,
        screenType: ScreenType
    ): TextLayoutConfig {
    const rawPos = textPosition ?? TextPosition.TOP;
    const isDesktop = screenType === ScreenType.DESKTOP;

    const effectivePos = rawPos === TextPosition.CARD ? TextPosition.TOP : rawPos;

    const isSide =
        effectivePos === TextPosition.SIDE ||
        effectivePos === TextPosition.SIDE_REVERSED;

    const showSideTitle = isDesktop && isSide;
    const showMainTitle = !showSideTitle;

    const variant: TextLayoutVariant =
        showSideTitle
            ? (effectivePos === TextPosition.SIDE_REVERSED ? 'SIDE_REVERSED' : 'SIDE')
            : 'TOP';
    
    const verticalAlign = isSide ? 'CENTER' : 'TOP';
    return {
        variant,
        showSideTitle,
        showMainTitle,
        verticalAlign
        };
}
}